<template>
  <el-autocomplete style="width:100%" :size="size"
    v-model="street" :trigger-on-focus="triggerOnFocus"
    :disabled="disabled"
    :fetch-suggestions="autoCompleteApi"
    :placeholder="placeholder()" 
    suffix-icon="el-icon-search"
    clearable
    @select="placeDetailApi">
  </el-autocomplete>
</template>

<script>
  import request from '@/utils/request'
  import { uuid } from 'vue-uuid'

  export default {
    props: {
      prefix: {
        type: String
      },
      full: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: 'medium'
      },
      code: {
        type: String,
        default: 'address'
      },
      disabled: {
        type:Boolean,
        default: false
      },
      restrict: {
        type:Boolean,
        default: false
      },
      lang: {
        type: String,
        default: '...'
      },
      search: String
    },
    computed: {
      street: {
        get: function() {
          return this.search
        },
        set: function(value) {
          this.$emit('update:search', value)
        }
      }
    },
    data: function() {
      return {
        triggerOnFocus: false,
        predictions: [],
        loading: false,
        address: '',
        session_token: ''
      }
    },
    created() {
      this.initSessionToken()
    },
    methods: {
      placeholder() {
        let ret = this.$t('employee.lbl.address.street')
        switch(this.code) {
          case 'city': {
            ret = this.$t('employee.lbl.address.city')
          }
            break
        }
        return ret
      },
      initSessionToken() {
        this.session_token = uuid.v4()
      },
      autoCompleteApi(p_value, callback) {
        if (this.prefix && this.prefix > '') {
          p_value = this.prefix + ',' + p_value
        }
        request({
          url: '/google/place/autocomplete/' + this.session_token + '/' + p_value + '/' + this.restrict,
          method: 'get'
        }).then(resp => {
          let results = []
          resp.data.predictions.map(item => {
            results.push({value: item.description, place_id: item.place_id})
          })
          callback(results)
        }).catch(err => {

        })
      },
      placeDetailApi(p_value) {
        request({
          url: '/google/place/detail/' + this.session_token + '/' + p_value.place_id + '/' + this.lang,
          method: 'get'
        }).then(resp => {
          if (this.full) {
            this.street = resp.data.street + ' ' + resp.data.street_number + ', ' + resp.data.city + ', ' + resp.data.postal_code + ', ' + resp.data.country
            resp.data.text = this.street
          }
          else {
            this.street = resp.data.street + ' ' + resp.data.street_number
          }
          this.$emit('complete', resp.data)
          this.initSessionToken()
        }).catch(err => {

        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/HMGoogleAddress/index.vue